// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, dashboardProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetDashboardApi = createAsyncThunk("hitGetDashboardApi", async () => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("professionalToken")}`,
      },
    };
    const url = ApiBaseUrl + dashboardProfessional;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    if(error.response.status === 401){
      localStorage.removeItem("professionalToken");
      localStorage.removeItem("professionalId");
      localStorage.removeItem("professionalData");
      window.location.href = "/professional/login";
    }
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const GetDashboardProfessionalSlice = createSlice({
  name: "getDashboardProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitGetDashboardData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetDashboardApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetDashboardApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
          if (action.payload?.status == true) {
          localStorage.setItem("professionalToken", action.payload.data.profile.accessToken);
          localStorage.setItem("professionalId", action.payload.data.profile._id);
          localStorage.setItem("professionalData", JSON.stringify(action.payload.data.profile));
        }
      })
      .addCase(hitGetDashboardApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitGetDashboardData } = GetDashboardProfessionalSlice.actions;
export default GetDashboardProfessionalSlice.reducer;
